module.exports = __webpack_public_path__ + "images/cebsb_logo.1792381924319.png";